import { DateTime } from "luxon";
import { parseDateOperatorValues } from "./filterDateOperatorUtils";

export function normalizeFilterDateMillis(dateValue: unknown): number | null {
  if (dateValue instanceof Date) {
    const normalizedDate = DateTime.fromJSDate(dateValue).startOf("day");
    return normalizedDate.isValid ? normalizedDate.toMillis() : null;
  }

  if (typeof dateValue === "string") {
    const normalizedDate = DateTime.fromISO(dateValue).startOf("day");
    return normalizedDate.isValid ? normalizedDate.toMillis() : null;
  }

  return null;
}

export function isWithinAfterBoundary(
  projectDateMillis: number,
  afterDateIso?: string,
) {
  if (!afterDateIso) {
    return true;
  }

  const afterDate = DateTime.fromISO(afterDateIso).startOf("day");
  const afterDateMillis = afterDate.isValid ? afterDate.toMillis() : null;

  return afterDateMillis !== null && projectDateMillis >= afterDateMillis;
}

export function isWithinBeforeBoundary(
  projectDateMillis: number,
  beforeDateIso?: string,
) {
  if (!beforeDateIso) {
    return true;
  }

  const beforeDate = DateTime.fromISO(beforeDateIso).startOf("day");
  const beforeDateMillis = beforeDate.isValid ? beforeDate.toMillis() : null;

  return beforeDateMillis !== null && projectDateMillis <= beforeDateMillis;
}

export function matchesDateOperatorFilters(
  projectDateValue: unknown,
  values: string[],
) {
  const parsedValues = parseDateOperatorValues(values);

  if (!parsedValues.after && !parsedValues.before) {
    return true;
  }

  if (!projectDateValue) {
    return false;
  }

  const projectDateMillis = normalizeFilterDateMillis(projectDateValue);

  if (projectDateMillis === null) {
    return false;
  }

  return (
    isWithinAfterBoundary(projectDateMillis, parsedValues.after) &&
    isWithinBeforeBoundary(projectDateMillis, parsedValues.before)
  );
}